<template>
    <div class="flex flex-col">
        <ul :class="{ 'max-h-80 overflow-y-scroll': post.pledges.length === limit, hidden: post.pledges.length !== limit }" class="flex flex-col pb-3 px-1 text-gray-900 whitespace-nowrap text-sm space-y-5 lg:block xl:px-4">
            <li v-for="(pledge, i) in orderedPledges">
                <div class="relative">
                    <span v-if="i !== orderedPledges.length - 1" aria-hidden="true" class="timeline-line absolute left-5 top-6 -ml-px w-0.5 h-full bg-gray-300 xl:left-6"></span>
                    <div class="relative flex space-x-3">
                        <div class="flex items-center">
                            <avatar :user="pledge.user" class="w-10 h-10 xl:w-12 xl:h-12" />
                        </div>
                        <div class="flex flex-1 items-center justify-between min-w-0 space-x-4">
                            <div class="flex flex-col">
                                <span class="text-gray-900 dark:text-slate-200 truncate">{{ pledge.user.tag }}</span>
                                <span class="font-medium dark:text-slate-200">${{ pledge.amount | abbr }}</span>
                            </div>
                            <div class="hidden text-right dark:text-slate-200 xl:block">
                                <time :datetime="formatDateTime(pledge.createdAt)">
                                    {{ pledge.createdAt | ago }}
                                </time>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
            <li v-if="post.pledges.length > limit" class="relative left-2.5 xl:pt-2">
                <button class="has-tooltip flex items-center -mt-4 text-gray-500 dark:text-slate-200 hover:text-indigo-500 dark:hover:text-slate-400 text-sm" @click="viewAllPledges">
                    + {{ post.pledges.length - limit }} pledges
                    <tooltip>View All</tooltip>
                </button>
            </li>
        </ul>

        <button v-if="post.pledges.length !== limit" class="-mt-4 px-3 py-4 hover:text-indigo-500 text-indigo-700 text-sm uppercase sm:mt-0 lg:hidden" @click="viewAllPledges">View Pledges</button>
    </div>
</template>

<script>
import Tooltip from "@/Components/Tooltip"

export default {
    name: "pledgeFeed",
    components: { Tooltip },
    props: ["post"],
    data() {
        return {
            limit: 5,
        }
    },
    computed: {
        orderedPledges() {
            return _.take(_.orderBy(this.post.pledges, "createdAt", "desc"), this.limit)
        },
    },

    methods: {
        formatDateTime(date) {
            return moment.utc(date).local().format("YYYY-MM-DD HH:mm:ss")
        },

        viewAllPledges() {
            this.limit = this.post.pledges.length
        },
    },
}
</script>
